// extracted by mini-css-extract-plugin
export default {"modalContent":"addEditBooksModal_modalContent__74Py4","formMarginTop":"addEditBooksModal_formMarginTop__T4fwq","previewImg":"addEditBooksModal_previewImg__qEIk4"};